<script setup lang="ts">
import AppButton2 from '~/components/AppButton2.vue'
import CmsLink from '~/layers/cms/app/components/cms/CmsLink.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Buttons/Button2'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <CmsLink
      v-slot="{ link }"
      :cms-data-path="[...props.cmsDataPath, 'component_data', 'link']"
      class="w-fit"
    >
      <AppButton2
        :href="link?.href"
        :target="link?.target"
      >
        <span class="link-text">{{ link?.link_text ?? 'Lorem ipsum' }}</span>
      </AppButton2>
    </CmsLink>
  </CmsCustomComponent>
</template>
